import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  AnalyticsGranularity,
  AnalyticsTicketsGroupBy,
  AnalyticsResponse,
  AnalyticsGroupBy,
  AnalyticsTickets
} from "src/app/backend/models/analytics";
import { environment } from "src/environments/environment";

@Injectable()
export class AnalyticsTicketsBackend {
  private readonly http = inject(HttpClient);

  list({
    from,
    to,
    granularity,
    groupBy
  }: {
    from: string;
    to: string;
    granularity: AnalyticsGranularity | "none";
    groupBy: AnalyticsGroupBy;
  }): Observable<AnalyticsResponse<AnalyticsTickets>> {
    return this.http
      .get<AnalyticsResponse<AnalyticsTickets>>(
        `${environment.snoots.api.analytics}/tickets`,
        {
          params: {
            from,
            to,
            granularity,
            groupBy
          }
        }
      )
      .pipe(
        map((response) => ({
          ...response,
          totalAverage: response.totalAverage || 0
        }))
      );
  }

  export(params: {
    from: string;
    to: string;
    granularity: AnalyticsGranularity | "none";
    groupBy: AnalyticsTicketsGroupBy;
  }): Observable<void> {
    return this.http.post<void>(
      `${environment.snoots.api.analytics}/tickets/exports`,
      {
        from: params.from,
        to: params.to,
        granularity: params.granularity,
        groupBy: params.groupBy
      }
    );
  }
}
